import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

// Paths
import { Munch } from './IconPaths';

const ANIM_DURATION = 0.4;

class MunchIcon extends React.Component {
  constructor(props) {
    super(props);

    this._icon = null;
    this._motionPaths = [null, null, null];
    this._food = [null, null, null];
  }
  _initAnimations() {

    const topLip = this._icon.querySelector('#lip-top');
    const bottomLip = this._icon.querySelector('#lip-bottom');
    const leftCheek = this._icon.querySelector('#cheek-left');
    const rightCheek = this._icon.querySelector('#cheek-right');

    const mouseClosedData = this._icon.querySelector('#mouth-closed').getAttribute('d');
    const leftCheekMunchData = this._icon.querySelector('#cheek-left-a').getAttribute('d');
    const rightCheekMunchData = this._icon.querySelector('#cheek-right-a').getAttribute('d');

    this._motionPaths[0] = this._icon.querySelector('#motion-path-1').getAttribute('d');
    this._motionPaths[1] = this._icon.querySelector('#motion-path-2').getAttribute('d');

    TweenMax.to(topLip, ANIM_DURATION, {
      morphSVG: mouseClosedData,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true
    });

    TweenMax.to(bottomLip, ANIM_DURATION, {
      morphSVG: mouseClosedData,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true
    });

    TweenMax.to(leftCheek, ANIM_DURATION, {
      morphSVG: leftCheekMunchData,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true
    });

    TweenMax.to(rightCheek, ANIM_DURATION, {
      morphSVG: rightCheekMunchData,
      ease: Power2.easeInOut,
      repeat: -1,
      yoyo: true
    });


    _.times(2, i => {
      const bezierData = MorphSVGPlugin.pathDataToBezier(this._motionPaths[i], {
        align: this._food[i]
      });
      TweenMax.set(this._food[i], { xPercent: -50, yPercent: -50 });
      TweenMax.to(this._food[i], ANIM_DURATION * 2, {
        scale: 0.5,
        bezier: {
          values: bezierData,
          type: 'cubic'
        },
        ease: Linear.easeNone,
        repeat: -1,
        yoyo: false,
        delay: 0.1 * i
      })
    });
  }
  componentDidMount() {
    this._initAnimations();
  }
  render() {
    const { foodColor, strokeColor, width, height } = this.props;

    return (
      <svg viewBox='0 0 100 100' width={width} height={height}>
        <g ref={icon => { this._icon = icon; }}>
          <Munch transform={'translate(0, 0)'} strokeColor={strokeColor} />
        </g>
        <g>
          <circle ref={food => { this._food[0] = food; }} r={3} cx={70} cy={100} fill={'none'} stroke={foodColor} strokeWidth={2} />
          <circle ref={food => { this._food[1] = food; }} r={2} cx={70} cy={100} fill={'none'} stroke={foodColor} strokeWidth={2} />
        </g>
      </svg>
    );
  }
};

MunchIcon.propTypes = {
  foodColor: PropTypes.string,
  strokeColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

MunchIcon.defaultProps = {
  foodColor: 'black',
  strokeColor: 'black',
  width: 200,
  height: 200
};

export default MunchIcon;



// WEBPACK FOOTER //
// ./src/components/AnimatedIcons/MunchIcon.jsx